import { apiSlice } from "../apiSlice";
import { filterUrl } from "../../config/config";

// Label map for display
const LABEL_MAP = {
  brand: "Brand",
  spare: "Spares",
  sort: "Sort",
  price: "Price Range",
};

export const masterSpareFilterApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMasterSpareFilters: builder.query({
      query: ({ category }) => filterUrl(category),
      transformResponse: (responseData) => {
        // Map labels and filter out unwanted filters
        return responseData.data
          .map((f) => ({ ...f, label: LABEL_MAP[f.filter] ?? f.filter }))
          .filter((f) => f.filter !== "sort" && f.filter !== "price");
      },
      providesTags: (result, error, arg) => {
        const tagType = `${arg.category}MasterSpareFilters`;
        if (!result) return [{ type: tagType, id: tagType }];
        return [
          { type: tagType, id: tagType },
          ...result.map((f) => ({ type: tagType, id: f.filter })),
        ];
      },
    }),
  }),
});

export const { useGetMasterSpareFiltersQuery } = masterSpareFilterApi;
